import React, {Component, useEffect, useState} from 'react'
import {message} from 'antd';

import {reqOrderRemarks} from "../../api";
//操作类型
const OPT_TYPE = {reject: '审核失败', pass: '审核通过', cancel: '取消订单',};
export default function ImportOrder({orderId}) {
    const [remarkList, setRemarkList] = useState([]);
    useEffect(() => {
        orderId && getRemarkList(orderId)
    }, [orderId]);
    const getRemarkList = async (orderId) => {
        let result = await reqOrderRemarks(orderId);
        if (result.code == 200) {
            setRemarkList(result.data)
        } else {
            message.error(result.message)
        }
    };
    return (Array.isArray(remarkList) && remarkList.length > 0 && <div className="order-info-details">
            {remarkList.map(o => {
                return <div className='order-info-item'>
                    [{o.createDt}] {OPT_TYPE[o.optType]} {o.remark}
                </div>
            })}
        </div>
    )
}